var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',_vm._g(_vm._b({staticClass:"Avatar",attrs:{"height":"48","data-title":_vm.username}},'v-avatar',[_vm.defaultsAttrs, _vm.$attrs],false),_vm.$listeners),[_c('span',{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.initials))])])}
var staticRenderFns = []

export { render, staticRenderFns }